import { connect } from 'react-redux'
import { actions } from './NotificationsSlice'
import Notifications from './components/Notifications'

const mapStateToProps = state => ({
  notifications: state.notificationsReducer.notifications
})

const mapDispatchToProps = dispatch => ({
  dismissSnackbar: uid =>
    setTimeout(() => {
      // Allow snackbar dismissal animation to finish before removal
      dispatch(actions.notificationsDequeue(uid))
    }, 250)
})

export default connect(mapStateToProps, mapDispatchToProps)(Notifications)
